import React from "react";

import RootRoute from "Routes/RootRoute";

import "Styles/main.scss";

const App = () => <RootRoute />;

export default App;
